import { useState } from 'react';
import { Box, Divider, Flex, Icon, Select, Text } from '@chakra-ui/react';
import {
	FiChevronLeft,
	FiChevronRight,
	FiChevronsLeft,
	FiChevronsRight,
} from 'react-icons/fi';
import { ClienteDTO } from '../../../dtos/ClienteDTO';

const porPage = [10, 15, 20, 25, 30];

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};

interface DTPaginateParams {
	pesq_length: number;
	pesqClientes: ClienteDTO[];
	controls: ControlsData;
	setControls: (control: ControlsData) => void;
	handleUpdateList: (
		page: number,
		perPage: number,
		clientes: ClienteDTO[],
	) => void;
}

const DTPaginate: React.FC<DTPaginateParams> = ({
	pesq_length,
	pesqClientes,
	controls,
	setControls,
	handleUpdateList,
}) => {
	function next() {
		let auxPage = controls.page + 1;

		if (auxPage > controls.totalPage) {
			auxPage -= 1;
		}
		setControls({ ...controls, page: auxPage });

		handleUpdateList(auxPage, controls.perPage, pesqClientes);
	}

	function prev() {
		let auxPage = controls.page - 1;

		if (auxPage < 1) {
			auxPage += 1;
		}
		setControls({ ...controls, page: auxPage });

		handleUpdateList(auxPage, controls.perPage, pesqClientes);
	}

	function goTo(page: number) {
		if (page < 1) {
			page = 1;
		}

		setControls({ ...controls, page });

		if (controls.page > controls.totalPage) {
			setControls({ ...controls, page: controls.totalPage });
		}

		handleUpdateList(page, controls.perPage, pesqClientes);
	}

	async function handleControlsPerPage(event: string) {
		const perPage = Number(event);

		setControls({
			page: 1,
			perPage,
			totalPage: Math.ceil(pesq_length / perPage),
		});

		handleUpdateList(1, perPage, pesqClientes);
	}

	return (
		<Flex w="100%" p="2" flexDir="column">
			<Divider orientation="horizontal" size="sm" />

			<Flex
				flexDir={['column', 'row']}
				justify="center"
				align="center"
				w="100%"
				p="2"
			>
				{/* POR PÁGINA */}
				<Flex as="form" justify="end" align="center">
					<Text fontSize="13" fontWeight="500" color="gray.400" mr="1">
						items por pag.
					</Text>
					<Box>
						<Select
							name="per_page"
							size="xs"
							fontWeight="500"
							onChange={e => handleControlsPerPage(e.target.value)}
						>
							{porPage.map(pPage => {
								return (
									<option key={pPage} value={pPage}>
										{pPage}
									</option>
								);
							})}
						</Select>
					</Box>
				</Flex>

				{/* INDICES */}
				<Flex align="center" px="2">
					<Text fontSize="13" fontWeight="500" color="gray.400">
						{controls.page * controls.perPage > pesq_length
							? pesq_length
							: `${controls.page * controls.perPage - controls.perPage + 1}
								- ${controls.page * controls.perPage} de ${pesq_length}`}
					</Text>
				</Flex>

				{/* SETAS */}
				<Flex align="center" px="2">
					<Text as="button" px={['2', '0']} onClick={() => goTo(1)}>
						<Icon as={FiChevronsLeft} fontSize="32" color="gray.400" />
					</Text>

					<Text as="button" px={['2', '0']} onClick={prev}>
						<Icon as={FiChevronLeft} fontSize="30" color="gray.400" />
					</Text>

					<Text as="button" px={['2', '0']} onClick={next}>
						<Icon as={FiChevronRight} fontSize="30" color="gray.400" />
					</Text>

					<Text
						as="button"
						px={['2', '0']}
						onClick={() => goTo(controls.totalPage)}
					>
						<Icon as={FiChevronsRight} fontSize="32" color="gray.400" />
					</Text>
				</Flex>
			</Flex>
		</Flex>
	);
};

export default DTPaginate;